var _excluded = ["property"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { AllhomesListingBadges } from './allhomes-listing-badges';
import { ListingBadgesFragmentDoc } from './listing-badges.fragment.generated';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = ListingBadgesFragmentDoc;
export var AllhomesListingBadgesGraphQL = _ref => {
  var property = _ref.property,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX(AllhomesListingBadges, _extends({
    annotations: property.listing.annotations
  }, props));
};
AllhomesListingBadgesGraphQL.fragment = fragment;